import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { useCoreDispatch } from '../../../../store/CoreStore';
import { useChatSlice } from '../../../../store/slices/chat/selectors';
import { chatActions } from '../../../../store/slices/chat/slice';
import { Chat } from '../../../chat/chat/Chat';
import { ChatFooterConnected } from '../../../chat/chat/footer/ChatFooterConnected';
import { MessagesWrapperConnected } from '../../../chat/chat/messages/messagesWrapper/MessagesWrapperConnected';

export const NavPageSupportConnected: FunctionComponent = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const liveSupportChatMessages = useChatSlice.getLiveSupportChatMessages();

  useEffect(() => {
    // When player opens support chat, we mark notification as read
    dispatch(chatActions.setLiveSupportReadStatus(true));
  }, [dispatch]);

  return (
    <Chat
      chatFooter={<ChatFooterConnected />}
      messagesWrapper={<MessagesWrapperConnected messages={liveSupportChatMessages} />}
    />
  );
};
